import React, { useState, useEffect } from "react";

// Default certifications data as fallback
const defaultCertifications = [
  {
    name: "National Association of Tax Professionals (NATP)",
    //logo: "https://natptax.com/wp-content/uploads/2020/09/natp_logo.svg"
  },
  {
    name: "American Institute of Certified Public Accountants (AICPA)",
    //logo: "https://www.aicpa-cima.com/content/dam/aicpa/images/logos/AICPA-logo-square.png"
  },
  {
    name: "National Association of Enrolled Agents (NAEA)",
    //logo: "https://www.naea.org/wp-content/uploads/2019/07/NAEA_Logo.png"
  }
];

export default function Portfolio({ content }) {
  const [index, setIndex] = useState(0);
  const [slideDir, setSlideDir] = useState("left"); // "left" or "right"

  // Slide automatically
  useEffect(() => {
    const timer = setInterval(() => {
      setSlideDir("left");
      setIndex(prev => (prev + 1) % certifications.length);
    }, 3000);
    return () => clearInterval(timer);
  }, []);

  // Swipe handler (optional for manual swipe, you can enhance if needed)
  const handlePrev = () => {
    setSlideDir("right");
    setIndex(prev => (prev - 1 + certifications.length) % certifications.length);
  };
  const handleNext = () => {
    setSlideDir("left");
    setIndex(prev => (prev + 1) % certifications.length);
  };

  // Use API content if available, otherwise fall back to default
  const certifications = content?.certifications || defaultCertifications;
  const { name, logo } = certifications[index];

  return (
    <section className="my-5 py-4 bg-white shadow-sm rounded-4 position-relative overflow-hidden certification-carousel">
      <div style={{ minHeight: 170, position: "relative" }}>
        {/* Swiping container */}
        <div
          className={`cert-swipe fade-in-${slideDir}`}
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            position: "absolute",
            width: "100%",
            left: 0,
            top: 0,
            transition: "transform 0.6s cubic-bezier(.85,.03,.41,1.04), opacity 0.5s",
            zIndex: 2
          }}
        >
          {/* {logo && (
            <img
              src={logo}
              alt={name}
              style={{ maxWidth: 100, maxHeight: 64, objectFit: "contain", marginBottom: 13 }}
            />
          )} */}
          <h2 className="display-4 fw-bold mb-4" style={{ fontFamily: "Poppins, sans-serif", color: "#15d6ddff" }}>
            Our Certifications and Affiliations
          </h2>
          <h4
            className="fw-bold mb-0 text-center"
            style={{
              fontFamily: "'Poppins',sans-serif",
              background: "linear-gradient(90deg,#6B46C1,#D53F8C 85%)",
              color: "transparent",
              WebkitBackgroundClip: "text",
              backgroundClip: "text"
            }}
          >
            {name}
          </h4>
        </div>

        {/* Optional Left/Right arrows for manual swipe (desktop only, hidden on mobile) */}
        <button onClick={handlePrev} aria-label="Previous" className="btn btn-light rounded-circle cert-nav-btn d-none d-md-flex" style={{ position: "absolute", top: "50%", left: 8, zIndex: 3, transform: "translateY(-50%)" }}>
          <i className="bi bi-chevron-left"></i>
        </button>
        <button onClick={handleNext} aria-label="Next" className="btn btn-light rounded-circle cert-nav-btn d-none d-md-flex" style={{ position: "absolute", top: "50%", right: 8, zIndex: 3, transform: "translateY(-50%)" }}>
          <i className="bi bi-chevron-right"></i>
        </button>
      </div>
      <style>{`
        .certification-carousel {
          min-height: 180px;
        }
        .cert-swipe {
          opacity: 1;
          transform: translateX(0%);
        }
        .fade-in-left {
          animation: cert-slide-left 0.6s;
        }
        .fade-in-right {
          animation: cert-slide-right 0.6s;
        }
        @keyframes cert-slide-left {
          0% { opacity: 0; transform: translateX(40%);}
          100% { opacity: 1; transform: translateX(0);}
        }
        @keyframes cert-slide-right {
          0% { opacity: 0; transform: translateX(-40%);}
          100% { opacity: 1; transform: translateX(0);}
        }
        .cert-nav-btn {
          background: #f3effd !important;
          color: #6B46C1 !important;
          border: none;
          box-shadow: 0 2px 9px #6b46c11a;
          font-size: 1.45rem;
        }
        .cert-nav-btn:active { box-shadow: 0 0 0 #fff !important; }
      `}</style>
      {/* Bootstrap Icons CDN if needed */}
      <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.10.3/font/bootstrap-icons.css" />
    </section>
  );
}
